import { authorizedApi } from './index';

export const phoneVerificationApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    sendOtpCode: builder.mutation({
      query: ({ phoneNumber }) => ({
        url: '/phone-verification/send-otp',
        method: 'POST',
        body: { phoneNumber },
      }),
    }),
    verifyOtpCode: builder.mutation({
      query: ({ code, phoneNumber }) => ({
        url: '/phone-verification/verify-otp',
        method: 'POST',
        body: { code, phoneNumber },
      }),
    }),
  }),
});

export const { useSendOtpCodeMutation, useVerifyOtpCodeMutation } =
  phoneVerificationApi;
